import React from "react";

import LoadingIndicator from "../../../../shared/seller-services/components/LoadingIndicator";
import * as S from "./styled";

const HomeClaimLoadingView = () => (
  <S.LoadingViewContainer>
    <LoadingIndicator />
  </S.LoadingViewContainer>
);

export default HomeClaimLoadingView;
